/**
 * @file Web Gallery Blog Post.
 */

import React from 'react';
import PropTypes from 'prop-types';

import { BLOG_POST_LINK_TYPE } from '../../../constants/blog';
import { getWebGalleryBlogPostLinkData } from '../utilities/web-galleries';
import Button from '../../../components/global/Button';
import Badge from '../../../components/global/Badge';

const propTypes = {
  blogPostLink: PropTypes.shape({
    album: PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
    }),
    album_folder: PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
    }),
    album_photo_group: PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
    }),
    id: PropTypes.string,
    link_type: PropTypes.oneOf(Object.values(BLOG_POST_LINK_TYPE)),
  }),
  className: PropTypes.string,
  size: PropTypes.oneOf(['xs', 'sm', 'lg']),
};

const WebGalleryBlogPostLink = ({
  blogPostLink,
  className = '',
  size = 'lg',
}) => {
  const blogPostData = getWebGalleryBlogPostLinkData(blogPostLink);

  return (
    <Button
      data-testid="blog-post-link-button"
      btnStyle="reset"
      to={blogPostData.link}
      className={className}
    >
      <Badge badgeStyle="yellow" badgeSize={size}>
        {blogPostData.name}
      </Badge>
    </Button>
  );
};

WebGalleryBlogPostLink.propTypes = propTypes;

export default WebGalleryBlogPostLink;
